import React,{useEffect,useState} from 'react'
export const DatePicker=React.memo((props)=> {
let init;
const [state,setState]=useState({loader:true});
  useEffect(()=>{
    const script=document.createElement("script");
   script.async=true;
   script.src="/assets/plugins/bootstrap-datepicker/dist/js/bootstrap-datepicker.min.js"
   document.body.appendChild(script);
   setTimeout(()=>{
    setState((pre)=>{
      return {...pre,loader:false}
     })
   },1000)
   return ()=>{
    script.remove()
   }
   
  },[])
  
  useEffect(()=>{
  if(!state.loader && !init){
    init=window.$(`#${props.type}`).datepicker({
      autoclose: true,
      endDate:props.endDate,
      }).on('changeDate', function(e) {
      props.handler(e.format(),props.type);  
  });
  // window.$(`#${props.type}`).datepicker("setDate",props.date);
  }
  
  },[state])

   if(!state.loader){
    return (
        <>
        <div class="mb-3">
				<label class="form-label text-white fw-bold">{props.name}</label>
        <input type="text" class="form-control text-white" id={props.type} placeholder="dd/mm/yyyy" />
        </div>
        </>
      )
   }
   else{
    <div>Loading</div>
   }
 
})
